import { useRef, useState } from 'react';
import { sendMessage } from './use-message';

export const useAddMember = (
  url: string,
  messages: {
    failure: string;
    success: string;
  }
) => {
  const abortControllerRef = useRef<AbortController>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const execute = async (data: FormData, onCompletion: () => void) => {
    setIsSubmitting(true);

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const response = await fetch(url, {
        /**
         * The URLSearchParams constructor type is wrong.
         * See https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/URLSearchParams#options.
         *
         * > A literal sequence of name-value string pairs, or any object — such as a FormData object
         */
        //@ts-expect-error
        body: new URLSearchParams(data),
        headers: { accept: 'application/json' },
        method: 'post',
        signal: abortController.signal,
      });

      sendMessage(
        response.ok
          ? { text: messages.success, theme: 'success' }
          : { text: messages.failure, theme: 'error' }
      );
    } finally {
      setIsSubmitting(false);
      onCompletion();
    }
  };

  return [execute, isSubmitting] satisfies [
    typeof execute,
    typeof isSubmitting,
  ];
};
